import * as z from "zod";
import { threePlDateRangeInput } from "./three-pl-date-range-input";

const returnsCenterLocationSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const get3plDashboardMetrics = {
  name: "get3plDashboardMetrics" as const,
  input: threePlDateRangeInput,
  output: z.object({
    // Returns KPIs
    avgProcessingTimeDays: z.number().nullable(),
    totalReturnsProcessedCount: z.number(),
    processingTimeSampleCount: z.number(),
    totalItemsProcessed: z.number(),
    processedWithin3DaysCount: z.number(),

    // Fulfillment KPIs
    avgFulfillmentTimeDays: z.number().nullable(),
    totalFulfillmentsCount: z.number(),
    ordersInRangeCount: z.number(),
    noonCutoffMetCount: z.number(),

    // Filter options
    returnsCenterLocations: z.array(returnsCenterLocationSchema),
  }),
};

export type ThreePlDashboardMetricsOutput = z.infer<
  (typeof get3plDashboardMetrics)["output"]
>;
